<template>

 <div>
     <el-button type="warning" v-if="(change || newPsw || isSuper() || form.login === profile().login)" :disabled="(!newPsw && !change) || disabled" @click="changePassword">{{title}} Password</el-button>
     <el-button type="danger" v-if="isSuper() && !newPsw" :disabled="!isSuper() || true" @click="resetPassword">Reset Password</el-button>

   <el-dialog class="text-left" :title="title + ' Password'" :visible.sync="changePsw">

     <password-form v-if="!loading" v-model="form" :change="change" :new-psw="newPsw" :inline="false" :toggle="toggle" />

     <template #footer><span class="dialog-footer">
       <el-button @click="changePsw = false">Cancel</el-button>
       <el-button type="success" @click="savePsw" :disabled="!passwordsMatch">Save</el-button>
     </span></template>
   </el-dialog>
 </div>


 </div>

</template>

<script>

import PostMixins from '@/mixins/PostMixins'

import PasswordForm from '@/components/login/PasswordForm'

export default {

  mixins: [PostMixins],

  components: {
    PasswordForm
  },

  props: {
    value: {
      required: true
    },

    toggle: {
      type: Boolean,
      default: true
    },

    change: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: true
    },

    newPsw: {
      type: Boolean,
      default: false
    },

  },

  watch: {

    value: function (d) {
      this.form = d
//      console.log('PasswordDialog', this.form, this.change)
    }

  },


  computed: {
    passwordsMatch: function () {

      if (this.form.password && this.form.c_password && this.form.password.length >= 7) {
        return (this.form.password === this.form.c_password)
      }

    return false
    }
  },




  methods: {
    savePsw () {

      if (this.changePsw) {
         this.changePsw = false
         this.form.password = this.form.password.trim()

         // XOL-391: never post without an id. PUT /password/change/{id} needs a
         // saved contact; with no id saveForm() would fall through to a POST at
         // /password/change, which matches no route. ContactDetail already hides
         // this control while adding (setting a credential at create time is
         // deferred to XOL-392), so this is a defensive stop for any other
         // caller rather than a reachable path today.
         if (!this.form.id) {
           this.$message({
             type: 'warning',
             message: 'Save the contact first, then set its password.'
           })
           return
         }

         let pass = {
           password: this.form.password,
           email: this.form.email
         }

         // XOL-371: allowViewOnly=true (last arg) — a view-only user may rotate
         // their OWN password; the button only shows for the own record and the
         // API keeps /password/change self-only + exempt from the write-block.
         this.saveForm(this, '/password/change', this.form.id, pass,  'Change Password', this.changePasswordSuccess, null, true, null, false, true)
      }

    },

    changePassword () {
      this.changePsw = true
    },

    formChange (data) {
      this.loading = false
      this.form = data
    },

    resetPasswordSuccess (data) {

      this.$alert('Reset e-mail to ' + this.form.email, 'Reset Password',
       {
        confirmButtonText: '  OK'
      }
    )

    },

    resetPassword() {
      this.saveForm(this, '/password/reset', this.form.id, null,  'Reset Password', this.resetPasswordSuccess)
    }

  },

  data () {
    return {
      changePsw: false,
      resetPsw: false,
      loading: true,
      form: this.value,
      title: (this.newPsw ? 'New' : 'Change')
    }
  },

  created () {
    // XOL-391: `c_password` is never part of a contact record (it is not a DB
    // column), so on a fresh form the key is absent and `v-model="form.c_password"`
    // would write a NON-reactive property — the passwordsMatch computed would
    // not re-evaluate as the confirm field is typed. Seed both keys reactively.
    if (this.form) {
      if (!Object.prototype.hasOwnProperty.call(this.form, 'password')) {
        this.$set(this.form, 'password', null)
      }
      if (!Object.prototype.hasOwnProperty.call(this.form, 'c_password')) {
        this.$set(this.form, 'c_password', null)
      }
    }

    // XOL-391: only fetch when there is a real contact to fetch. ContactDetail
    // mounts this with a bare `change` attribute (always true), including in
    // add mode, so a new contact has no `form.id` — the URL became
    // /contacts/undefined and the API answered 422 ("Contact not found"),
    // surfacing an error toast before the user had typed anything. Guard here
    // rather than at the call site so every consumer is covered.
    //
    // `loading` gates <password-form v-if="!loading">, and it was only ever
    // cleared by formChange() — the SUCCESS callback of that fetch. With no
    // fetch to run, a new contact left loading true forever, so the dialog
    // opened completely empty and no password could be set at all. Clear it
    // explicitly when there is nothing to load.
    if (this.change && this.form && this.form.id) {
      this.fetchData('/contacts/' + this.form.id, this.formChange, 'Contact')
    } else {
      this.loading = false
    }
  }
}

</script>
